module.exports = __webpack_public_path__ + "img/vac-iso.2b4189ba.jpg";